module.exports = __webpack_public_path__ + "media/images/envelope-stripes-1-3ec6109f57fcca1bc2d443473bc413d7.png";